import React from 'react';
import BaseInstallmentsStep from './BaseInstallmentsStep';
import { useInstallmentsStepSecond } from '../../../../../hooks/installments/useInstallmentsStepSecond';

const InstallmentsStepSecondCall = (context) => {
    const {
        selectedValue,
        setSelectedValue,
        amountTarget,
        setAmountTarget,
        idsPlan,
        installmentAllowed,
        handleAmountChange,
        showFeeValues,
        extraContent,
        isLoading,
        disabledNext,
    } = useInstallmentsStepSecond(context);

    return (
        <BaseInstallmentsStep
            context={context}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            amountTarget={amountTarget}
            setAmountTarget={setAmountTarget}
            idsPlan={idsPlan}
            installmentAllowed={installmentAllowed}
            handleAmountChange={handleAmountChange}
            showFeeValues={showFeeValues}
            extraContent={extraContent}
            isLoading={isLoading}
            disabledNext={disabledNext}
        />
    );
};

export default InstallmentsStepSecondCall;
